function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
import isPlainObject from 'lodash.isplainobject';
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    text: {
      type: Object,
      validator: function validator(value) {
        var obj = {
          deleting: 'string',
          paused: 'string',
          queued: 'string',
          retrying_upload: 'string',
          submitted: 'string',
          submitting: 'string',
          uploading: 'string',
          upload_failed: 'string',
          upload_successful: 'string'
        };

        if (!isPlainObject(value)) {
          return false;
        }

        var keys = Object.keys(obj);
        var valueKeys = Object.keys(value);
        return valueKeys.every(function (key) {
          if (keys.indexOf(key) === -1) {
            return false;
          }

          return _typeof(value[key]) === obj[key];
        });
      },
      default: function _default() {
        return Object({
          deleting: 'Deleting...',
          paused: 'Paused',
          queued: 'Queued',
          retrying_upload: 'Retrying...',
          submitted: 'Submitted',
          submitting: 'Submitting...',
          uploading: 'Uploading...',
          upload_failed: 'Failed',
          upload_successful: 'Completed'
        });
      }
    },
    uploader: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var defaultText = {
      deleting: 'Deleting...',
      paused: 'Paused',
      queued: 'Queued',
      retrying_upload: 'Retrying...',
      submitted: 'Submitted',
      submitting: 'Submitting...',
      uploading: 'Uploading...',
      upload_failed: 'Failed',
      upload_successful: 'Completed'
    };
    return {
      state: {
        status: '',
        text: Object.assign({}, defaultText, this.text || {})
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange); // Read the status of the file when we start up
    // in case it was already submitted, and there won't be a
    // status change event to react to.

    var uploads = this.uploader.methods.getUploads();
    var fileStatus = null;
    uploads.forEach(function (upload) {
      if (upload.id === this.id) {
        fileStatus = upload.status;
      }
    }, this);

    if (fileStatus !== null) {
      this._onStatusChange(this.id, null, fileStatus);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;

    this._unregisterStatusChangeHandler();
  },
  watch: {
    text: function text(newValue, oldValue) {
      this.$set(this.state, 'text', Object.assign({}, this.state.text, newValue));
    }
  },
  methods: {
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted) {
        var newStatusToDisplay = this.getStatusToDisplay({
          displayMap: this.state.text,
          status: newStatus
        });
        newStatusToDisplay && this.$set(this.state, 'status', newStatusToDisplay);
      }
    },
    _unregisterStatusChangeHandler: function _unregisterStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    },
    getStatusToDisplay: function getStatusToDisplay(_ref) {
      var displayMap = _ref.displayMap,
          status = _ref.status;
      var key;

      if (status.indexOf(' ') > 0) {
        var statusParts = status.split(' ');
        key = "".concat(statusParts[0], "_").concat(statusParts[1]);
      } else {
        key = status;
      }

      return displayMap[key];
    }
  }
};